/** @file tileDraftKey: the key of a Tile tab's draft, `<puppet>/<drawable>/<entry>/<tile>`. */
import { slotKey } from '@zilo/pose3d-format/derive/slotKey';
import type { TileRef } from '../../state/editorTypes';

/** The puppet id, then the tile's slot key: drafts of two puppets never share a key. */
export function tileDraftKey(puppetId: string, ref: TileRef): string {
  return `${puppetId}/${slotKey(ref.drawable, ref.entry, ref.tile)}`;
}
